<template>
  <div class="card-container" :class="[card.format, card.style]">
      <div class="card-logo">
        <a target="_blank" href="https://www.icij.org/investigations/luanda-leaks"><img :src="logo" /></a>
      </div>
      <div class="card-meta">
        <div v-if="card.format == 'year'" class="card-icon">
          <a target="_blank" :href="urlTo"><img :src="imgIcon" class="img-icon" /></a target="_blank">
        </div>
        <div v-if="card.elements" class="card-elements">
          <a target="_blank" :href="urlTo"><animate-element :controller="controller" v-for="(element, id) in elements" :element="element" :key="id" /></a target="_blank">
        </div>
        <div class="card-meta__container">
          <div v-if="imgHeader" class="card-header embed-image">
            <a target="_blank" :href="urlTo"><img :src="imgHeader" /></a>
          </div>
          <div v-if="card.date" class="card-date"> <a target="_blank" :href="urlTo"><span v-html="card.date"></span></a></div>
          <h2 class="card-title"> <a target="_blank" :href="urlTo" v-html="titleCard"></a></h2>
          <div v-if="card.format == 'year'" class="card-period">
            <a target="_blank" v-if="chapter.period" :href="urlTo">{{ chapter.period }}</a>
          </div>
          <div class="card-read-more">
            <a target="_blank" :href="urlTo">{{ readMore }}</a target="_blank">
          </div>
        </div>
      </div>

      <div v-if="bgImage" class="card-bg-image embed-image">
        <a target="_blank" :href="urlTo"><img :src="bgImage" /></a>
      </div>
      
      <div v-if="headerSticky" class="card-header-sticky embed-image">
        <a target="_blank" :href="urlTo"><img :src="headerSticky" /></a>
      </div>
      
  </div>
</template>

<script>

import animateElement from './animateElement.vue'
import shareStory from './shareStory.vue'

export default {
  name: "cardEmbed",
  components: {
    animateElement,
    shareStory
  },
  props: {
    card: Object,
    elements: Array,
    controller: Object,
    chapter: Object,
    url: String
  },
  computed: {
    urlTo() {
      return this.url+"?slide_story="+this.card.id
    },
    readMore() {
      return this.card.desc_widget ? this.card.desc_widget : "Read our investigation"
    },
    titleCard() {
      return this.card.title_widget ? this.card.title_widget : this.card.title
    },
    imgHeader() {
      if(this.card.imgHeader)
        return require("../assets/"+this.card.imgHeader)
      return false
    },
    headerSticky() {
      if(this.card.headerSticky)
        return require("../assets/"+this.card.headerSticky)
      return false
    },
    bgImage() {
      if(this.card.bgImage)
        return require("../assets/"+this.card.bgImage)
      return false
    },
    imgFooter() {
      if(this.card.imgFooter)
        return require("../assets/"+this.card.imgFooter)
      return false
    },
    imgIcon() {
      if(this.chapter.icon)
        return require("../assets/"+this.chapter.icon)
      return false
    },
    logo() {
      return require("../assets/logo_black.png")
    }
  }
}

</script>

<style lang="scss">

  .card-interactive-wrapper {
    height: 90vh;
    background: #333;

    .card-elements {
      position: sticky;
      top: 0;
      width: 100%;
      max-width: 1420px;
      height: 100vh;
      margin: 0 auto;

      img {
        width: 100% !important;
      }
    }

    .embed-image {
      width: 50%;
      padding: 0 15px;
    }

    .card-container {
      margin: 0 auto;
      height: 85vh;
      opacity: 1;
      transition: opacity .25s ease-in;    

      &.fullsize {
        display: flex;
        align-items: center;
      }

      &.text .card-meta__container {
        text-align: center;
        margin: 0 auto;
      }

      &.text .card-meta__container .card-title {
        margin: 0;
        text-align: center;
      }

      &.text .card-meta__container .card-date {
        margin: 0;
        text-align: center;
      }

      &.text .card-meta__container .card-period {
        text-align: center;
      }
      
      img {
        width: 100%;
      }

      p {
        margin-bottom: 25px;
        font-family: 'Merriweather', serif;
        font-size: 18px;
      }

      p.quote {
        font-family: 'Merriweather', serif;
        font-size: 27px;
        font-weight: 600;
        line-height: 1.5em;
        color: #b9b476;
      }

      .quote__author {
        font-weight: 400;
      }

      .dropcap {
        float: left;
        padding: 0;
        margin-right: 15px;
        font-family: 'Merriweather', serif;
        font-size: 145px;
        line-height: 115px;
      }

      ul {
        padding-left: 25px;
      }

      li {
        list-style: circle;
        margin-bottom: 20px;
        font-family: 'Merriweather', serif;
        font-size: 18px;
      }

      a {
        color: #fff;
        text-decoration: none !important;
        border-bottom: none;
      }

      h2 {
        margin: 10px 0;
        font-size: 41px;
        font-weight: 900;
        line-height: 1.2em;
        color: #fff;
      }
    }

    .card-container.year .img-icon {
      width: 100%;
      max-width: 100%;
    }

    .card-read-more {
      margin: 15px 0;
      font-family: 'Lato', sans-serif;
      font-size: 21px;

      a {
        color: #fff;
        line-height: 1.3em;
      }
    }

    .card-container.year h2 {
      font-size: 31px;
    }

    .card-header {
      position: relative;
      width: 100%;
      max-width: 640px;
      margin: 0 auto;
      z-index: 99;
    }

    .card-header-sticky {
      position: absolute;
      display: flex;
      top: 0;
      right: 0;
      width: 100%;
      height: 100vh;
      padding: 0;
      overflow: hidden;
      opacity: 0.4;
      align-items: flex-start;
      justify-content: center;

      img {
        max-width: 920px;
      }
    }

    .animate-layer {
      position: relative !important;
      height: auto !important;

      img {
        max-width: 400px !important;
      }
    }

    .card-bg-image {
      position: absolute;
      top: 0;
      right: 0;

      img {
        padding: 0;
      }
    }

    .card-logo {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      max-width: 100px;
      padding: 15px;

      img {
        padding: 0;
      }
    }

    .card-period {
      font-family: 'Lato', sans-serif;
      font-size: 16px;
      font-weight: 900;
      text-align: left;
      
      a {
        color: #9c9c9c;
      }
    }

    .card-title {
      text-align: left;
      text-shadow: none !important;
    }

    .card-chapter {
      font-size: 21px;
      font-weight: 400;
      color: #777777;
      line-height: 1.2em;
    }

    .card-meta {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      max-width: 920px;
      height: 90vh;
      margin: 0 auto;
      z-index: 99;

      &__container {
        width: 100%;
        max-width: 480px;
        padding: 15px;
      }
    }

    .fit .card-meta {
      align-items: flex-end;
    }

    .card-icon {
        float: left;
        width: 100%;
        max-width: 300px;
        margin-right: 15px;
      }

    @media (min-width: 570px) and (max-width: 720px) {
    
      .card-read-more {
        font-size: 15px;
      }
      
    }

    @media (min-width: 200px) and (max-width: 560px) {
      .card-meta {
        display: block;
        margin-top: 15vh;

        &__container {
          width: calc(100%);
          text-align: center;
          padding: 0 15px;
          margin: 0;
        }

        .card-date {
          margin: 5px 0;
          text-align: center;
        }

        .card-title {
          margin: 5px 0;
          text-align: center;
          color: #fff;
        }

        .card-period {
          margin: 5px 0;
          text-align: center;
        }

        .card-read-more a {
          color: #c7c4c4;
        }

        .card-elements {
          height: auto !important;
        }

        .animate-layer {
          text-align: center;
        }

        .animate-layer img {
          width: 100%;
          max-width: 290px !important;
        }
      }

      .card-container.year img.img-icon {
        width: 65% !important;
      }

      .card-header-sticky {
        top: 55vh !important;
      }

      .card-icon {
        float: none;
        width: 100%;
        max-width: 320px;
        margin: 0 auto;
        margin-top: 0;
        text-align: center;
      }
      
      .card-container.year .img-icon {
        width: 100%;
        max-width: 320px;
      }

      .card-container h2 {
        margin: 10px !important;
        font-size: 31px !important;
      }

      .card-read-more {
        margin: 5px 0;
        font-family: 'Lato', sans-serif;
        font-size: 16px;
        line-height: 1.2em;
      }
    }


    
    .card-date {
      display: block;
      margin: 15px 0;
      font-family: 'Lato', sans-serif;
      font-size: 21px;
      font-weight: 900;
      text-align: left;

      span {
        color: #ce1429;
      }
    }

    .card-story {
      max-width: 640px;
      padding: 15px;
      margin: 0 auto;
      padding: 15px;
      margin-top: 50px;
      font-family: 'Lato', sans-serif;
      text-align: left;
      transition: margin-top .55s ease-in;
    }

    .card-content-container {
      width: 100%;
      max-width: 1120px;
      margin: 0 auto;
    }

    .card-content {
      position: relative;
      margin: 25px auto;
      padding: 15px;
      font-family: 'Merriweather', serif;
      font-size: 18px;
      line-height: 28px;
      z-index: 99;
    }
  }
</style>
